<div class="sidebar tw-flex tw-flex-column">
  <div class="selectors tw-flex tw-flex-column tw-gap-3 tw-mb-3">
    <mg-form-grouped-select
      class="block-assignment-input"
      [id]="'tools-myclass-click-search-action'"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_SEARCH_ACTION"
      [placeholder]="MESSAGES.FORM_LABEL_SEARCH_ACTION"
      [clearOnSelect]="true"
      [options]="groupedOptions$ | async"
      [resetMenuOnClose]="true"
      (selectChange)="searchActionChange($any($event))">
    </mg-form-grouped-select>

    <mg-form-select
      *ngIf="categories$ | async"
      class="categories"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_CATEGORY_SELECTION"
      [control]="form.get(FORM_FIELDS.CATEGORY)"
      [placeholder]="MESSAGES.FORM_LABEL_CATEGORY"
      [options]="categories$ | async"
      [closeOnSelect]="true"
      (selectionChanged)="onCategoryChange($event)">
      <ng-template let-item="item">
        <div
          class="option-category"
          fxLayout="row"
          fxLayoutAlign="start center"
          fxLayoutGap="8px"
          [ngClass]="'myclass-category-' + item.label | slugify"
          [attr.data-analytics]="item.id"
          [attr.data-test]="item.id">
          <mg-icon
            [iconName]="item.icon"
            [icon-namespace]="item?.iconNamespace"></mg-icon>
          <mg-text variant="body-md">
            {{ item.label }}
          </mg-text>
        </div>
      </ng-template>
    </mg-form-select>
  </div>

  <ng-container *ngIf="assignmentActions$ | async as assignmentActions">
    <div
      class="tiles"
      tabindex="0"
      #sidebarTiles>
      <div
        *ngIf="assignmentActions?.length > 0; else empty"
        class="tiles-wrap tw-flex tw-flex-column tw-gap-2">
        <mg-sa-tile
          *ngFor="let item of assignmentActions"
          [ngClass]="'myclass-tile-' + item.action?.category.label + '-' + item.action.value | slugify"
          [tile]="item.tile"
          [selected]="
            form.get(FORM_FIELDS.SELECTED_ACTION).value?.value === item.action.value &&
            form.get(FORM_FIELDS.SELECTED_ACTION).value?.assignmentType === item.action.assignmentType
          "
          (pressed)="selectAction(item.action)"></mg-sa-tile>
      </div>

      <ng-template #empty>
        <mg-empty-state
          class="empty-state"
          [title]="MESSAGES.MOST_USED_EMPTY_TITLE"
          [subtitle]="MESSAGES.MOST_USED_EMPTY_SUBTITLE"></mg-empty-state>
      </ng-template>
    </div>
  </ng-container>

  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>
